import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { AppTypesFormState } from '../models/LocalServiceModels/AppTypesFormState';

@Injectable({
  providedIn: 'root'
})
export class CommonDataSharedService {

  private eMutabakatSelected = new Subject<any>();
  currentSelection = this.eMutabakatSelected.asObservable()

  constructor() { }

  sendMutabakatSelections(AppTypes:AppTypesFormState){
    this.eMutabakatSelected.next(AppTypes)
  }
}
